import * as React from "react";
import type { SVGProps } from "react";
const SvgCartesBancaires = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#29abe2"
      d="M2 7a2 2 0 0 1 2-2h15.998a2 2 0 0 1 2 2v9.72a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
    />
    <path
      fill="url(#cartes-bancaires_svg__a)"
      d="M2 7a2 2 0 0 1 2-2h15.998a2 2 0 0 1 2 2v9.72a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
    />
    <path
      fill="url(#cartes-bancaires_svg__b)"
      d="M2 7a2 2 0 0 1 2-2h15.998a2 2 0 0 1 2 2v9.72a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
    />
    <path
      fill="#fff"
      d="M12.872 7.916h5.34a1.866 1.866 0 1 1 0 3.733h-5.34zm0 4.156h5.34a1.866 1.866 0 1 1 0 3.732h-5.34zm-4.654 0v-.423h4.298a4.163 4.163 0 0 0-4.298-3.733 4.133 4.133 0 0 0-4.3 3.944 4.133 4.133 0 0 0 4.3 3.944 4.16 4.16 0 0 0 4.298-3.732z"
    />
    <defs>
      <radialGradient
        id="cartes-bancaires_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(20.2702 0 0 19.054 3.11 18.353)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.09} stopColor="#009245" />
        <stop offset={0.23} stopColor="#049552" stopOpacity={0.89} />
        <stop offset={0.52} stopColor="#0d9e74" stopOpacity={0.59} />
        <stop offset={0.91} stopColor="#1bacab" stopOpacity={0.12} />
        <stop offset={1} stopColor="#1fb0b8" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="cartes-bancaires_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="translate(6.45 19.528)scale(26.0045)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.15} stopColor="#1fb0b8" stopOpacity={0} />
        <stop offset={0.35} stopColor="#1c7491" stopOpacity={0.4} />
        <stop offset={0.56} stopColor="#1a4471" stopOpacity={0.73} />
        <stop offset={0.74} stopColor="#18265e" stopOpacity={0.93} />
        <stop offset={0.87} stopColor="#181b57" />
      </radialGradient>
    </defs>
  </svg>
);
export default SvgCartesBancaires;
